import React from 'react';

const CollapseIconSVGR = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='22' height='20' viewBox='0 0 28 18'>
    <g>
      <g>
        <g>
          <path
            fill='#fff'
            d='M25.764 2.727H1.509C.647 2.727 0 2.094 0 1.364 0 .584.7 0 1.51 0h24.254c.862 0 1.509.633 1.509 1.364 0 .73-.647 1.363-1.51 1.363z'
          />
        </g>
        <g>
          <path
            fill='#fff'
            d='M25.764 10.367H1.509C.647 10.367 0 9.734 0 9c0-.776.7-1.36 1.51-1.36h24.254c.862 0 1.509.633 1.509 1.36 0 .783-.647 1.367-1.51 1.367z'
          />
        </g>
        <g>
          <path
            fill='#fff'
            d='M25.764 18H1.509C.647 18 0 17.364 0 16.634c0-.78.7-1.364 1.51-1.364h24.254c.862 0 1.509.633 1.509 1.364 0 .73-.647 1.366-1.51 1.366z'
          />
        </g>
      </g>
    </g>
  </svg>
);

export default CollapseIconSVGR;
